/** Figma vertical arrow width 191.944 / default vertical asset 208. */
export const FIGMA_VERTICAL_ARROW_SCALE = 191.94403076171875 / 208;

/** Default left for list / license / stickers / tasks arrows. */
export const FIGMA_VERTICAL_ARROW_LEFT = 444.037109375;

/** Frame bottom reference used by Figma list layouts. */
export const FIGMA_ARROW_FRAME_BOTTOM = 1634.08203125;

export function computeArrowDownTop(
  frameBottom: number = FIGMA_ARROW_FRAME_BOTTOM,
  scale: number = FIGMA_VERTICAL_ARROW_SCALE,
): number {
  return frameBottom - 84 * scale;
}

export function createVerticalArrowPositions(
  upTop: number,
  downTop: number = computeArrowDownTop(),
  left: number = FIGMA_VERTICAL_ARROW_LEFT,
) {
  return {
    up: { left, top: upTop },
    down: { left, top: downTop },
  } as const;
}
